
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppSelect, AppCard, AppButton } from '@/components';
import { usePromotionPlanTranslate } from '@/modules/promotion/plan/model/translate';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';

export default defineComponent({
    name: ROUTE_NAME_PROMOTION.PLAN.TRANSLATE,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, beforeFetch, actions, localeSupportedOptions } = usePromotionPlanTranslate();

        onMounted(async () => {
            await beforeFetch();
            await fetch();
        });

        return { v$, model, fetch, actions, localeSupportedOptions };
    }
});
